import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareCustomHeaders } from "../utils/baseQueryHeaders";
import { SegmentationItemBase } from "../translation/types";

type SegmentationRequestBody = {
  regex: string;
  source_resource: string;
  target_resource?: string;
  job_id?: number;
  force?: boolean;
};

export const CATViewApi = createApi({
  reducerPath: "CATViewApi",
  tagTypes: ["CATView"],
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/_internal/cat/",
    prepareHeaders: prepareCustomHeaders,
  }),
  endpoints: (build) => ({
    segmentation: build.mutation<
      SegmentationItemBase[],
      SegmentationRequestBody
    >({
      query: (data) => ({
        url: "segmentation/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CATView"],
    }),
    validateRegex: build.mutation<{ error: string | null }, string>({
      query: (regex) => ({
        url: `validate-regex/`,
        method: "POST",
        body: { regex },
      }),
    }),
  }),
});

export const { useSegmentationMutation, useValidateRegexMutation } = CATViewApi;
